const polarSector = (r, theta) => {
  const theta_copy = Array.from(theta);
  //sort the r_copy array to find the max and min
  theta_copy.sort((a, b) => a - b);
  const minAngle = theta_copy[0];
  const maxAngle = theta_copy[theta_copy.length - 1];
  console.log({ minAngle, maxAngle });
  const data = [
    {
      type: "scatterpolar",
      mode: "lines",
      r: r.map((v) => -v),
      theta: theta,
      line: {
        color: "#ff66ab",
      },
      marker: {
        color: "#8090c7",
        symbol: "square",
        size: 8,
      },
      //   subplot: "polar"
    },
  ];

  const layout = {
    showlegend: false,
    title: "Historique direction vent 2h",
    polar: {
      // sector: [minAngle, maxAngle],
      // sector: [45, 135],
      // domain: {
      //   x: [0, 0.4],
      //   y: [0, 1],
      // },
      radialaxis: {
        tickfont: {
          size: 8,
        },
        // tickmode: "array",
        // tickvals: [0, 60, 120],
        // ticktext: ["-2h", "-1h", "0"],
      },
      angularaxis: {
        tickfont: {
          size: 8,
        },
        //rotation: 90,
        direction: "clockwise",
      },
    },
  };

  // Plotly.newPlot('myDiv', data, layout)
  return { data, layout };
};
export default polarSector;
